import { defineMessages } from "react-intl";

import {
	currentlySmokingMessages,
	validator
} from "lib/build/forms/basic-health/risks/smoking";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	smoking: {
		id: "form.smoking",
		defaultMessage: "Dohányzás"
	},
	currentlySmoking: {
		id: "form.smoking.currently_smoking",
		defaultMessage: "Aktuálisan dohányzik?"
	}
});

const fields: { [key: string]: FieldData } = {
	currentlySmoking: {
		type: "field",
		path: ["currentlySmoking"],
		label: messages.currentlySmoking,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: currentlySmokingMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.currentlySmoking }] }]
};

export const node: LeafNode = {
	id: "bh_smoking",
	value: {
		schemaId: "smoking",
		title: messages.smoking,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
